import { service } from "../../../../../Project/service/service";
import { serviceUsers } from "../../../../service";
import { CreateProjectUsers, Roles, UserRole } from "../model";

function verefyIsEmpty(object: any, returnOne: string, returnTwo: string, typeOfOperator: string, hoursBase: number): string {
  if (object[returnOne] === "") return calculos(object, typeOfOperator, returnTwo, hoursBase);

  return replaceNumberToString(object[returnOne]);
}

function replaceNumberToString(value: any): string {
  if (!value) return "";
  return String(value).replaceAll(",", ".");
}

function calculos(object: any, typeValue: string, fieldSecondary: string, hourBase?: number | undefined) {
  if (!hourBase) return String(0);
  return typeValue === "/"
    ? String((Number(replaceNumberToString(object[fieldSecondary])) / hourBase)?.toFixed(2))
    : String(Number(Number(replaceNumberToString(object[fieldSecondary])) * hourBase)?.toFixed(2));
}

function gerateDinamicObjectCollaborator(objeto: any, objetoInterno: any, campo: any, value: any) {
  const data = {
    ...objeto[objetoInterno],
    [campo]: value,
  };
  const obj = {
    ...objeto,
    [objetoInterno]: data,
  };

  return obj;
}

function convertStringInNumber(array: any[]) {
  const collaborator = [] as UserRole[];
  array?.forEach((item: UserRole) => {
    const rolesId: number[] = [];
    item.rolesId?.forEach((number: any) => {
      rolesId.push(Number(number));
    });
    collaborator.push({ userId: Number(item.userId), rolesId: rolesId });
  });
  return collaborator;
}

function getUsers(setValue: any, token: string) {
  serviceUsers.getUsers(token).then((data) => {
    setValue(data);
  });
}

function getRoles(setValue: any, token: string) {
  service.getRoles(token).then((data: Roles[]) => {
    const newList: Roles[] = [];
    data?.forEach((element: Roles) => {
      const data = {
        id: element.id,
        name: element.name,
        checked: false,
      };
      newList.push(data);
    });
    setValue(newList);
  });
}

function postProjects(formData: any, token: string) {
  return service
    .postProjects(formData, token)
    .then((data) => {
      return data;
    })
    .catch((err) => console.error(err));
}

function putProjects(formData: any, is_deleted: boolean, params: string, token: string) {
  const data: CreateProjectUsers = {
    ...formData,
    is_deleted: is_deleted,
  };
  return service
    .putProjects(data, params, token)
    .then((data) => {
      return data;
    })
    .catch((err) => console.error(err));
}

function objectGenerator(element: Roles) {
  const obj = {
    ...element,
    checked: !element.checked,
  };
  return obj;
}

function compareArrayAndInclude(arrayOne: any[], arrayTwo: any[]) {
  const newArray = arrayOne?.map((element: any) => {
    if (!arrayTwo.includes(element.name)) return element;
    const data = objectGenerator(element);
    return data;
  });
  return newArray;
}

async function delayTime(data: any, time: number) {
  return await setTimeout(() => {
    return data;
  }, time);
}

function returnIdLeadCommercial(roles: Roles[]) {
  const item = roles?.filter((item) => {
    if (item?.name === "LIDER-COMERCIAL") return true;
  });
  return item[0]?.id;
}

export {
  verefyIsEmpty,
  calculos,
  replaceNumberToString,
  gerateDinamicObjectCollaborator,
  convertStringInNumber,
  returnIdLeadCommercial,
  delayTime,
  compareArrayAndInclude,
  postProjects,
  putProjects,
  getUsers,
  getRoles,
  objectGenerator,
};
